import { jsPDF } from "jspdf";
import QRCode from "qrcode";

import { loadPdfTemplate } from "@/lib/brandAssets";
import { formatCurrency } from "@/lib/currency";
import { formatBoliviaDate } from "@/lib/dateTime";

export async function downloadQuotePdf(quote, settings) {
  const currency = (value) => formatCurrency(value, settings);
  const pdf = new jsPDF({ unit: "mm", format: "a4" });
  const qr = await QRCode.toDataURL(`Cotización ${quote.id}`);
  let template = null;
  try {
    template = await loadPdfTemplate();
  } catch (error) {
    console.warn("El PDF se generó sin plantilla institucional.", error);
  }

  const paintTemplate = () => {
    if (template) {
      pdf.addImage(template, "PNG", 0, 0, 210, 297);
    }
  };
  const section = (title, y) => {
    pdf.setTextColor(21, 74, 116);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(8);
    pdf.text(title.toUpperCase(), 18, y);
    pdf.setDrawColor(41, 153, 207);
    pdf.line(18, y + 3, 192, y + 3);
  };

  paintTemplate();
  pdf.setTextColor(21, 74, 116);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(18);
  pdf.text("COTIZACIÓN", 18, 70);
  pdf.setFontSize(8);
  pdf.setFont("helvetica", "normal");
  pdf.text(`Código ${quote.id.slice(-8).toUpperCase()}`, 18, 77);

  section("Datos del cliente", 91);
  pdf.setTextColor(35, 52, 66);
  pdf.setFontSize(9);
  let y = 102;
  const line = (label, value) => {
    pdf.setTextColor(21, 74, 116);
    pdf.setFont("helvetica", "bold");
    pdf.text(label, 20, y);
    pdf.setTextColor(35, 52, 66);
    pdf.setFont("helvetica", "normal");
    pdf.text(String(value), 66, y);
    pdf.setDrawColor(223, 231, 237);
    pdf.line(66, y + 2.5, 190, y + 2.5);
    y += 7;
  };
  line("Cliente", quote.client.nombre);
  line("CI", quote.client.ci);
  line("Teléfono", quote.client.celular);
  line("Fecha", formatBoliviaDate(quote.created_at));

  section("Lote seleccionado", y + 4);
  y += 15;
  line("Manzano / lote", `${quote.lot.manzano} / ${quote.lot.lote}`);
  line("Superficie", `${quote.lot.superficie} m²`);
  line("Precio por m²", currency(quote.lot.precio_m2));

  pdf.setFillColor(238, 247, 252);
  pdf.roundedRect(18, y + 2, 174, 49, 3, 3, "F");
  section("Resumen financiero", y + 12);
  const summary = [
    ["Precio total", currency(quote.precio_total)],
    ["Inicial", currency(quote.inicial)],
    ["Descuento", currency(quote.descuento)],
    ["Saldo financiado", currency(quote.saldo)],
    ["Plan", quote.meses ? `${quote.meses} cuotas` : "Pago al contado"],
    ["Valor cuota", quote.meses ? currency(quote.valor_cuota) : "—"],
  ];
  pdf.setFontSize(8.5);
  summary.forEach(([label, value], index) => {
    const column = index % 2;
    const row = Math.floor(index / 2);
    const x = column ? 110 : 23;
    const valueX = column ? 157 : 67;
    const itemY = y + 22 + row * 9;
    pdf.setTextColor(83, 105, 120);
    pdf.setFont("helvetica", "normal");
    pdf.text(label, x, itemY);
    pdf.setTextColor(21, 74, 116);
    pdf.setFont("helvetica", "bold");
    pdf.text(value, valueX, itemY, { align: "right" });
  });
  if (quote.observaciones) {
    pdf.setTextColor(83, 105, 120);
    pdf.setFont("helvetica", "italic");
    pdf.setFontSize(8);
    pdf.text(`Observaciones: ${quote.observaciones}`, 18, y + 60, { maxWidth: 174 });
  }
  pdf.setTextColor(83, 105, 120);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(7);
  pdf.text("VALIDACIÓN", 18, 224);
  pdf.addImage(qr, "PNG", 18, 227, 20, 20);

  pdf.addPage();
  paintTemplate();
  pdf.setTextColor(21, 74, 116);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(18);
  pdf.text("PLAN DE PAGOS", 18, 70);
  pdf.setFontSize(8);
  pdf.setFont("helvetica", "normal");
  pdf.text(`Cotización ${quote.id.slice(-8).toUpperCase()}`, 18, 77);
  let tableY = 91;
  const tableHeader = () => {
    pdf.setFillColor(21, 74, 116);
    pdf.rect(18, tableY - 6, 174, 8, "F");
    pdf.setTextColor(255, 255, 255);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(8);
    pdf.text("CUOTA", 22, tableY - 0.5);
    pdf.text("FECHA", 58, tableY - 0.5);
    pdf.text("MONTO", 108, tableY - 0.5);
    pdf.text("SALDO RESTANTE", 151, tableY - 0.5);
  };
  tableHeader();
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(8);
  quote.plan_pagos.forEach((payment) => {
    if (tableY > 230) {
      pdf.addPage();
      paintTemplate();
      tableY = 86;
      tableHeader();
    }
    pdf.setTextColor(35, 52, 66);
    pdf.text(String(payment.cuota), 22, tableY + 7);
    pdf.text(payment.fecha, 58, tableY + 7);
    pdf.text(currency(payment.monto), 108, tableY + 7);
    pdf.text(currency(payment.saldo_restante), 151, tableY + 7);
    pdf.setDrawColor(224, 231, 237);
    pdf.line(18, tableY + 10, 192, tableY + 10);
    tableY += 10;
  });
  pdf.save(`cotizacion-${quote.id.slice(-8)}.pdf`);
}
